module.exports = __webpack_public_path__ + "static/img/智慧零售赋能门店.ff66d0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/智慧零售赋能门店.jpg
// module id = wBbg
// module chunks = 13